"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdpEventModel", {
    enumerable: true,
    get: function() {
        return AdpEventModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const AdpEventModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    client_id: _zod.z.string(),
    event: _zod.z.object({
        confirmMessage: _zod.z.string().optional(),
        error: _zod.z.string().optional(),
        error_description: _zod.z.string().optional(),
        events: _zod.z.array(_zod.z.object({}))
    })
});
